(function ($) {
  headerNavRowV1 = {
    formatter: $('.header-nav-row-v1')
  };

  Drupal.behaviors.headerNavRowV1 = {
    get: function (key) {
      return headerNavRowV1[key];
    },

    set: function (key, val) {
      headerNavRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var img = thisFormatter.find('img');

        img.each(function () {
          var $img = $(this);
          var tempImg = new Image();

          tempImg.onload = function () {
            $img.attr('width', this.width);
            $img.attr('height', this.height);
          };
          tempImg.src = $img.attr('src');
        });
      });
    }
  };
})(jQuery);
